import LocationConfigClient from './location-config-client';
import Transliterator from './transliterator';
import LocationFilter from './location-filter';
import LocationConfigStorage from './location-config-storage';
import MapManager from './map-manager';
import GeoLocator from './geo-locator';

function geoLocatorFactory(NgMap) {
    const googleMapsLoader = () => NgMap.getMap();

    return new GeoLocator(googleMapsLoader);
}

geoLocatorFactory.$inject = ['NgMap'];

export default angular
    .module('paysera.locationsMap.services', [])
    .service('locationConfigClient', LocationConfigClient)
    .service('transliterator', Transliterator)
    .service('locationFilter', LocationFilter)
    .service('locationConfigStorage', LocationConfigStorage)
    .service('mapManager', MapManager)
    .factory('geoLocator', geoLocatorFactory)
    .name
;
